// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Apply`
};

const el_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Εφαρμογή`
};

const ru_apply = /** @type {(inputs: {}) => string} */ () => {
	return `Применить`
};

const he_apply = /** @type {(inputs: {}) => string} */ () => {
	return `החל`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const apply = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.apply(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("apply", locale)
	if (locale === "en") return en_apply(inputs)
	if (locale === "el") return el_apply(inputs)
	if (locale === "ru") return ru_apply(inputs)
	if (locale === "he") return he_apply(inputs)
	return "apply"
};